<template>
  <v-layout
    row
    wrap
  >
    <span class="filter-field ma-2 body-2">{{ filter.label }}</span>

    <v-menu
      v-model="dateFrom"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      class="ma-2"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="filter.from"
          :label="$t('Date from')"
          prepend-icon="event"
          readonly
          class="ma-2"
          dense
          solo
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="filter.from"
        @input="dateFrom = false"/>
    </v-menu>

    <v-menu
      v-model="dateTo"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      class="ma-2"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="filter.to"
          :label="$t('Date to')"
          prepend-icon="event"
          readonly
          class="ma-2"
          dense
          solo
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="filter.to"
        @input="dateTo= false"/>
    </v-menu>

    <v-icon
      @click="$emit('delete')"
    >
      cancel
    </v-icon>
  </v-layout>
</template>

<script>
export default {
  name: 'DateFilter',

  props: {
    filter: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  data () {
    return {
      dateFrom: false,
      dateTo: false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .v-icon {
    margin-top: -20px
  }
  .filter-field {
    margin-top: 20px !important
    min-width: 60px
  }
</style>
